import type { Organization } from '@eppendorf/vnls-user-tenant-utils';
import { useTranslation } from 'react-i18next';
import { OrganizationDetailRow } from '$features/organizations/detail/detail-tab/row';
import { OrganizationDetailRowSendInvite } from '$features/organizations/detail/detail-tab/row/organization-detail-row-send-invite';
import { OrganizationDetailRowSupportAccount } from '$features/organizations/detail/detail-tab/row/organization-detail-row-support-account';
import { getLocalizedDateFromUtcString } from '$shared/utils/date.utils';
import { getFullname } from '$shared/utils/get-fullname.util';

function getAdditionalFeatureLabel(feature: string): string {
  return feature === 'REPORT_HUB_ACCESS' ? 'Report Hub access' : feature;
}

export function OrganizationInfo({ organization }: { organization: Organization }) {
  const { t } = useTranslation();
  const additionalFeatures = organization.additionalFeatures ?? [];

  return (
    <div className="organization-details-content">
      <OrganizationDetailRow label={t('shared.id')} value={organization.id} />

      <OrganizationDetailRow label={t('organizationDetails.keylightContractId')} value={organization.keylightContractId ?? '-'} />

      <OrganizationDetailRow label={t('organizationDetails.name')} value={organization.name} />

      <OrganizationDetailRow label={t('organizationDetails.type')} value={organization.type ?? '-'} />

      <OrganizationDetailRow label={t('organizationDetails.subscription')} value={organization.subscription ?? '-'} />

      <OrganizationDetailRow label={t('organizationDetails.subscribedDevices')} value={organization.subscribedDevices?.toString() ?? '-'} />

      <OrganizationDetailRow
        label={t('organizationDetails.additionalFeatures')}
        value={additionalFeatures.length > 0 ? additionalFeatures.map(getAdditionalFeatureLabel).join(', ') : '-'}
      />

      <OrganizationDetailRow
        label={t('organizationDetails.contactName')}
        value={getFullname((organization as Organization).contactFirstName, organization.contactLastName)}
      />

      <OrganizationDetailRow label={t('organizationDetails.contactEmail')} value={organization.contactEmail} />

      <OrganizationDetailRow
        label={t('organizationDetails.adminName')}
        value={getFullname(organization.adminFirstName, organization.adminLastName)}
      />

      <OrganizationDetailRow label={t('organizationDetails.adminEmail')} value={organization.adminEmail} />

      <OrganizationDetailRow
        label={t('shared.created')}
        value={`${t('shared.by')} ${organization.createdBy} ${t('shared.on')} ${getLocalizedDateFromUtcString(organization.createdAt)}`}
      />

      <OrganizationDetailRowSupportAccount id={organization.id} />

      <OrganizationDetailRowSendInvite organization={organization} />
    </div>
  );
}
